<template>
  <v-container fluid>
    <v-row dense>
      <!-- Overlay-->
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
              @click="overlay = false"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <!-- Cabecera -->
      <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size: 30px" class="mb-0">Personas</p>
      </v-col>
      <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro = true">Registro</v-btn>
          <v-btn @click="registro = false">Admin</v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- Columna 1  - Persona, Stakeholder y Documentos -->
      <v-col cols="12" md="7" sm="12" xs="12" lg="7" xl="7" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <!--:search-input.sync="searchindividuo"
                flat
                hide-no-data
                hide-details
                solo-inverted
                :return-object="true"
              -->
              <v-autocomplete
                v-model="idindividuo"
                :items="personas"
                solo-inverted
                flat
                :filter="customFilterPersona"
                item-text="nombrecompleto"
                item-value="idindividuo"
                label="Buscar persona..."
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.nombrecompleto"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.dni"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Información persona -->
            <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" class="pt-5" dense>
              <span class="font-weight-bold primary--text"
                >Datos personales</span
              >
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-5">
                      <!--v-mask="'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'"-->
                      <v-text-field
                        v-model="nombres"
                        label="Nombres"
                        dense
                        class="pt-0 code"
                        :rules="[() => !!nombres || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="nombres"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-5">
                      <!--  v-mask="'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'" -->
                      <v-text-field
                        v-model="apellidos"
                        label="Apellidos"
                        dense
                        class="pt-0"
                        :rules="[() => !!apellidos || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="apellidos"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field
                        v-model="dni"
                        label="DNI"
                        dense
                        :rules="[() => !!dni || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="dni"
                        v-mask="'########'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="sexos"
                        v-model="sexo"
                        dense
                        class="pt-0"
                        label="Sexo"
                        :rules="[() => !!sexo || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="sexo"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="estadoscivil"
                        v-model="estado_civil"
                        label="Estado civil"
                        dense
                        class="pt-0"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <!-- type="date"
                              placeholder="dd/mm/yyyy"
                        v-mask="'##/##/####'"
                      -->
                      <v-text-field
                        v-model="fecha_nacimiento"
                        label="Fecha de nacimiento"
                        class="pt-0"
                        dense
                        max-width="43"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="jefes_hogar"
                        v-model="jefe_hogar"
                        label="Jefe de hogar"
                        class="pt-0"
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field
                        v-model="telefono"
                        label="Telefono"
                        dense
                        class="pt-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider class="mx-4" vertical></v-divider>
                <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="email"
                        label="Email"
                        dense
                        class="pt-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <!-- @focus="selectlocaciones" -->
                      <v-autocomplete
                        v-model="idlocacion"
                        :items="locaciones"
                        label="Locacion"
                        class="pt-0"
                        dense
                        :rules="[() => !!idlocacion || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="idlocacion"
                        required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="direccion"
                        label="Dirección"
                        dense
                        class="pt-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="tipos_persona"
                        v-model="tipo_persona"
                        label="Tipo según locacion"
                        class="pt-0"
                        dense
                        :rules="[() => !!tipo_persona || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="tipo_persona"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" class="pt-0">
                      <v-select
                        :items="tipos_postulante"
                        v-model="tipo_postulante"
                        label="Tipo de postulante"
                        dense
                        :rules="[() => !!tipo_postulante || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="tipo_postulante"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    class="mb-5"
                    @click="save"
                    :disabled="overlay2"
                    >Guardar</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <!-- Información actor social -->
            <v-col cols="12" md="12" sm="12" xs="12" dense>
              <v-row dense>
                <v-col cols="6" md="6" sm="12" xs="12" dense>
                  <span class="font-weight-bold primary--text"
                    >Información como actor social</span
                  >
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                  sm="12"
                  xs="12"
                  dense
                  class="d-flex justify-end"
                >
                  <v-btn
                    class="ma-2"
                    small
                    outlined
                    fab
                    color="primary"
                    @click.stop="abrirDialogStakeholder"
                    :disabled="nuevo"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogstakeholder" max-width="400px">
                    <v-card outlined class="pa-2">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <span class="font-weight-bold mb-2 justify-center"
                            >Formulario</span
                          >
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-text dense class="mt-4">
                        <v-row dense>
                          <v-col
                            cols="12"
                            md="7"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-select
                              :items="tipos_actor"
                              v-model="tipo_actor"
                              label="Tipo"
                              class="pt-0"
                              dense
                              :rules="[() => !!tipo_actor || 'Campo requerido']"
                              :error-messages="errorMessages"
                              ref="tipo_actor"
                              required
                            ></v-select>
                          </v-col>
                          <v-col
                            cols="12"
                            md="5"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-text-field
                              v-model="abreviaturaactor"
                              label="Abrevitura"
                              class="pt-0"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!--  v-mask="'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'"-->
                            <v-text-field
                              v-model="actor"
                              label="Actor social"
                              dense
                              class="pt-0"
                              :rules="[() => !!actor || 'Campo requerido']"
                              :error-messages="errorMessages"
                              ref="actor"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-text-field
                              v-model="descripcion"
                              label="Descripción"
                              class="pt-0"
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <v-btn
                            class="ma-2"
                            color="primary"
                            :disabled="overlay2"
                            @click="saveActores"
                            >Guardar</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="headersactores"
                    :items="actores"
                    hide-default-header
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="primary"
                        class="pr-1"
                        @click="editItemActor(item)"
                        >mdi-square-edit-outline</v-icon
                      >
                      <v-icon @click="deleteItemActor(item)" color="primary"
                        >mdi-delete</v-icon
                      >
                    </template>

                    <template v-slot:item.resumen="{ item }">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.stakeholder
                          }}</v-list-item-title>
                          <v-list-item-subtitle
                            >Tipo:
                            {{ item.tipo_stakeholder }}</v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            >Descripción:
                            {{ item.descripcion }}</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data
                      >No tiene registrada información como actor
                      social</template
                    >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <!-- Documento -->
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-5 pb-5" dense>
              <v-row dense class="pa-3">
                <v-col cols="12" md="12" sm="12" xs="12" dense>
                  <v-row dense>
                    <v-col cols="6" md="6" sm="12" xs="12" dense>
                      <span class="font-weight-bold primary--text"
                        >Documentos</span
                      >
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                      sm="12"
                      xs="12"
                      dense
                      class="d-flex justify-end"
                    >
                      <v-btn
                        class="ma-2"
                        small
                        outlined
                        fab
                        color="primary"
                        @click.stop="abrirDialogDocumento"
                        :disabled="nuevo"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-dialog v-model="dialogdocumento" max-width="400px">
                        <v-card outlined class="pa-2">
                          <v-row dense>
                            <v-col
                              cols="12"
                              md="12"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0 d-flex justify-center"
                            >
                              <span class="font-weight-bold mb-2 justify-center"
                                >Formulario</span
                              >
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-card-text dense class="mt-4">
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"
                                dense
                                class="pt-0"
                              >
                                <v-text-field
                                  v-model="documentonombre"
                                  label="Nombre"
                                  class="pt-0"
                                  :rules="[
                                    () =>
                                      !!documentonombre || 'Campo requerido',
                                  ]"
                                  :error-messages="errorMessages"
                                  ref="documentonombre"
                                  required
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"
                                dense
                                class="pt-0"
                              >
                                <v-textarea
                                  label="Descripcion"
                                  v-model="documentodescripcion"
                                  :rules="[
                                    () =>
                                      !!documentodescripcion ||
                                      'Campo requerido',
                                  ]"
                                  :error-messages="errorMessages"
                                  ref="documentodescripcion"
                                  :rows="2"
                                  required
                                  class="pt-0"
                                  dense
                                ></v-textarea>
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                                sm="12"
                                xs="12"
                                dense
                                class="pt-0"
                              >
                                <v-text-field
                                  v-model="documentoabreviatura"
                                  label="Abreviatura"
                                  class="pt-0"
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"
                                dense
                                class="pt-0"
                              >
                                <v-file-input
                                  label="Archivo"
                                  v-model="documentoruta"
                                ></v-file-input>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-row dense>
                            <v-col
                              cols="12"
                              md="12"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0 d-flex justify-center"
                            >
                              <v-btn
                                class="ma-2"
                                color="primary"
                                :disabled="overlay2"
                                @click="saveDocumento"
                                >Adjuntar</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense>
                      <v-data-table
                        :headers="headeredocumentos"
                        :items="documentos"
                        hide-default-header
                        hide-default-footer
                        class="elevation-1"
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-row>
                            <v-col cols="6"></v-col>
                          </v-row>
                          <v-icon
                            color="primary"
                            class="pr-1"
                            @click="editItemDocumento(item)"
                            >mdi-square-edit-outline</v-icon
                          >
                          <v-icon
                            @click="deleteItemDocumento(item)"
                            color="primary"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <template v-slot:item.resumen="{ item }">
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                item.nombre
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                >Detalle:
                                {{ item.descripcion }}</v-list-item-subtitle
                              >
                              <v-list-item-subtitle>
                                <small
                                  >Actualizado al
                                  {{ item.fecha_actualizacion }}</small
                                >
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:no-data
                          >No tiene documentos registrados</template
                        >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Columna 2  - Experiencia,Educacion y Conocimientos -->
      <v-col cols="12" md="5" sm="12" xs="12" lg="5" xl="5" dense v-if="registro">
        <v-card class="mx-auto" outlined>
          <v-row dense class="pa-3">
            <!-- Educacion-->
            <v-col cols="12" md="12" sm="12" xs="12" dense>
              <v-row dense>
                <v-col cols="6" md="6" sm="12" xs="12" dense>
                  <span class="font-weight-bold primary--text">Educación</span>
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                  sm="12"
                  xs="12"
                  dense
                  class="d-flex justify-end"
                >
                  <v-btn
                    class="ma-2"
                    small
                    outlined
                    fab
                    color="primary"
                    @click.stop="abrirDialogEducacion"
                    :disabled="nuevo"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogeducacion" max-width="400px">
                    <v-card outlined class="pa-2">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <span class="font-weight-bold mb-2 justify-center"
                            >Formulario</span
                          >
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-text dense class="mt-4">
                        <v-row dense>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-select
                              :items="educacion_tipos"
                              v-model="educaciontipo_educacion"
                              label="Grado academico"
                              class="pt-0"
                              :rules="[
                                () =>
                                  !!educaciontipo_educacion ||
                                  'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              ref="educaciontipo_educacion"
                              required
                            ></v-select>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!--:rules="[() => !!educaciondenominacion || 'Campo requerido']"
                              :error-messages="errorMessages"
                              ref="educaciondenominacion"
                               required
                               :search-input.sync="search"
                                  @input="searchInput=null"
                              :search-input.sync="searchInput"
                            -->
                            <v-combobox
                              v-model="educaciondenominacion"
                              :items="educaciones_principal"
                              item-text="educacion"
                              label="Educación / Carrera"
                              hide-selected
                              persistent-hint
                              small-chips
                              class="pt-0"
                              dense
                              :search-input.sync="search"
                              @keyup.enter="agregareducacion"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      No se encuentra resultados con la palabra
                                      "
                                      <strong>{{ search }}</strong
                                      >". Presione <kbd>enter</kbd> para crear
                                      uno nuevo
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-combobox>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!--:rules="[() => !!educacioninstitucion || 'Campo requerido']"
                              :error-messages="errorMessages"
                              ref="educacioninstitucion"
                            required-->
                            <!--  v-mask="'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'" -->

                            <v-text-field
                              v-model="educacioninstitucion"
                              label="Institucion/Universidad"
                              class="pt-0"
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <v-btn
                            class="ma-2"
                            color="primary"
                            :disabled="overlay2"
                            @click="saveEducacion"
                            >Guardar</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="headereducaciones"
                    :items="educaciones"
                    hide-default-header
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="primary"
                        class="pr-1"
                        @click="editItemEducacion(item)"
                        >mdi-square-edit-outline</v-icon
                      >
                      <v-icon @click="deleteItemEducacion(item)" color="primary"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <template v-slot:item.resumen="{ item }">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.denominacion
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.institucion
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <small>{{ item.tipo_educacion }}</small>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data
                      >No tiene registrada información sobre educación</template
                    >
                    <template v-slot:no-results>NO RESULTS HERE!</template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <!-- Experiencia -->
            <v-col cols="12" md="12" sm="12" xs="12" dense>
              <v-row dense>
                <v-col cols="6" md="6" sm="12" xs="12" dense>
                  <span class="font-weight-bold primary--text"
                    >Experiencia</span
                  >
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                  sm="12"
                  xs="12"
                  dense
                  class="d-flex justify-end"
                >
                  <v-btn
                    class="ma-2"
                    small
                    outlined
                    fab
                    color="primary"
                    @click.stop="abrirDialogExperiencia"
                    :disabled="nuevo"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogexperiencia" max-width="400px">
                    <v-card outlined class="pa-2">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <span class="font-weight-bold mb-2 justify-center"
                            >Formulario</span
                          >
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-text dense class="mt-4">
                        <v-row dense>
                          <!-- Experiencia_bateas-->
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0 pb-0"
                          >
                            <v-checkbox
                              v-model="experienciabateas"
                              label="Experiencia en Minera Bateas o contratistas"
                              class="pt-0 mt-0 pb-0 mt-0"
                              dense
                              @change="reiniciarArea"
                            ></v-checkbox>
                          </v-col>
                          <!-- Experiencia_area-->
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                            v-if="experienciabateas"
                          >
                            <v-autocomplete
                              v-model="areaid"
                              :items="areaarray"
                              label="Empresa - Area"
                              class="pt-0"
                              dense
                              @change="getEmpresa"
                            ></v-autocomplete>
                          </v-col>
                          <!-- Experiencia_actual-->
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-checkbox
                              v-model="experienciaactual"
                              label="Trabajo actualmente en esta empresa"
                              class="pt-0 mt-0"
                              dense
                            ></v-checkbox>
                          </v-col>
                          <!-- Experiencia_fechainicio-->
                          <v-col
                            cols="12"
                            md="6"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!--  placeholder="dd/mm/yyyy"
                              v-mask="'##/##/####'" -->
                            <v-text-field
                              v-model="experienciafechainicio"
                              label="Fecha de inicio"
                              class="pt-0"
                              dense
                              type="date"
                              max-width="43"
                              :rules="[
                                () =>
                                  !!experienciafechainicio || 'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              ref="experienciafechainicio"
                              required
                            ></v-text-field>
                          </v-col>
                          <!-- Experiencia_fechafin-->
                          <v-col
                            cols="12"
                            md="6"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!-- type="date" -->
                            <v-text-field
                              v-model="experienciafechafin"
                              label="Fecha de fin"
                              class="pt-0"
                              type="date"
                              dense
                              max-width="43"
                              :min="experienciafechainicio"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-text-field
                              v-model="experienciaempresa"
                              label="Empresa"
                              class="pt-0"
                              dense
                              :rules="[
                                () => !!experienciaempresa || 'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              ref="experienciaempresa"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <!-- v-mask="'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'" 
                             @input="searchInput = null"-->
                            <v-combobox
                              v-model="experienciapuesto"
                              :items="experiencias_principal"
                              item-text="puesto"
                              :search-input.sync="search"
                              label="Puesto / Cargo"
                              hide-selected
                              :rules="[
                                () => !!experienciapuesto || 'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              persistent-hint
                              small-chips
                              ref="experienciapuesto"
                              required
                              class="pt-0"
                              dense
                              @keyup.enter="agregarexperiencia"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      No se encuentra resultados con la palabra
                                      "
                                      <strong>{{ search }}</strong
                                      >". Presione <kbd>enter</kbd> para crear
                                      uno nuevo
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-combobox>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <v-btn
                            class="ma-2"
                            color="primary"
                            :disabled="overlay2"
                            @click="saveExperienciaFinal"
                            >Guardar</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="headerexperiencias"
                    :items="experiencias"
                    hide-default-header
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="primary"
                        class="pr-1"
                        @click="editItemExperencia(item)"
                        :disabled="tieneContrato(item)"
                        >mdi-square-edit-outline</v-icon
                      >
                      <v-icon
                        @click="deleteItemExperiencia(item)"
                        color="primary"
                        :disabled="tieneContrato(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <template v-slot:item.resumen="{ item }">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.puesto
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.empresa
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <small
                              >{{ item.fechainicio }} al {{ item.fechafin }}
                            </small>
                            <v-chip
                              class="ma-2"
                              x-small
                              color="primary"
                              v-if="item.actual"
                            >
                              Contrato vigente
                            </v-chip>
                            <v-chip class="ma-2" x-small v-else>
                              Contrato no vigente
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data
                      >No tiene registrada información sobre
                      experiencia</template
                    >
                    <template v-slot:no-results>NO RESULTS HERE!</template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <!-- Conocimiento -->
            <v-col cols="12" md="12" sm="12" xs="12" dense>
              <v-row dense>
                <v-col cols="6" md="6" sm="12" xs="12" dense>
                  <span class="font-weight-bold primary--text"
                    >Conocimiento</span
                  >
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                  sm="12"
                  xs="12"
                  dense
                  class="d-flex justify-end"
                >
                  <v-btn
                    class="ma-2"
                    small
                    outlined
                    fab
                    color="primary"
                    @click.stop="abrirDialogConocimiento"
                    :disabled="nuevo"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-dialog v-model="dialogconocimiento" max-width="400px">
                    <v-card outlined class="pa-2">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <span class="font-weight-bold mb-2 justify-center"
                            >Formulario</span
                          >
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-text dense class="mt-4">
                        <v-row dense>
                          <v-col
                            cols="12"
                            md="8"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-select
                              :items="conocimiento_tipos"
                              v-model="conocimientotipo_educacion"
                              label="Tipo"
                              class="pt-0"
                              dense
                              :rules="[
                                () =>
                                  !!conocimientotipo_educacion ||
                                  'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              ref="conocimientotipo_educacion"
                              required
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="12" sm="12" xs="12" dense>
                            <v-combobox
                              v-model="conocimientodenominacion"
                              :items="conocimientos_principal"
                              item-text="conocimiento"
                              @input="searchInput = null"
                              :search-input.sync="search"
                              label="Conocimiento / Habilidad"
                              hide-selected
                              :rules="[
                                () =>
                                  !!conocimientodenominacion ||
                                  'Campo requerido',
                              ]"
                              :error-messages="errorMessages"
                              persistent-hint
                              small-chips
                              ref="conocimientodenominacion"
                              required
                              class="pt-0"
                              dense
                              @keyup.enter="agregarconocimiento"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      No se encuentra resultados con la palabra
                                      "
                                      <strong>{{ search }}</strong
                                      >". Presione <kbd>enter</kbd> para crear
                                      uno nuevo
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-combobox>
                          </v-col>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xs="12"
                            dense
                            class="pt-0"
                          >
                            <v-text-field
                              v-model="conocimientoinstitucion"
                              label="Institucion/Universidad"
                              class="pt-0"
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          dense
                          class="pt-0 d-flex justify-center"
                        >
                          <v-btn
                            class="ma-2"
                            color="primary"
                            :disabled="overlay2"
                            @click="saveConocimiento"
                            >Guardar</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="headerconocimientos"
                    :items="conocimientos"
                    hide-default-header
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="primary"
                        class="pr-1"
                        @click="editItemConocimiento(item)"
                        >mdi-square-edit-outline</v-icon
                      >
                      <v-icon
                        @click="deleteItemConocimiento(item)"
                        color="primary"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <template v-slot:item.resumen="{ item }">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.denominacion
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.institucion
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <small>{{ item.tipo_educacion }}</small>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data
                      >No tiene registrada información sobre
                      conocimientos</template
                    >
                    <template v-slot:no-results>NO RESULTS HERE!</template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="persona_headers"
                :items="persona_items"
                :search="searchpersonas"
                sort-by="nombres"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Personas</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion == 1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion == 2">
                          <span class=".font-weight-thin"
                            >¿Desactivar item?</span
                          >
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion == 1">activar</span>
                          <span v-if="adAccion == 2">desactivar</span>
                          el item asoaciado a
                          <strong>{{ adNombre }}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            v-if="adAccion == 1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                            >Activar</v-btn
                          >
                          <v-btn
                            v-if="adAccion == 2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                            >Desactivar</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchpersonas"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <!-- Template para condicion -->
                <template v-slot:item.condicion="{ item }">
                  <v-switch
                    v-model="item.condicion"
                    inset
                    @change="ActivarDesactivar(item)"
                  ></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemPersona(item)"
                    >mdi-square-edit-outline</v-icon
                  >
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{ icon }}</v-icon>
        {{ error }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  //============== Data
  data() {
    return {
      //============== Data - Ayuda
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      errorMessages: "",
      form1HasErrors: false,
      form2HasErrors: false,
      form3HasErrors: false,
      form4HasErrors: false,
      form5HasErrors: false,
      form6HasErrors: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogstakeholder: false,
      dialogeducacion: false,
      dialogexperiencia: false,
      dialogconocimiento: false,
      dialogdocumento: false,
      search: "",
      searchInput: null,
      valida: 0,
      validamensaje: [],

      //============== Data - Administracion
      persona_headers: [
        {
          text: "DNI",
          sortable: false,
          value: "dni",
        },
        { text: "Nombres", value: "nombres" },
        { text: "Apellidos", value: "apellidos" },
        { text: "Sexo", value: "sexo" },
        { text: "Fecha de nacimiento", value: "fecha_nacimiento" },
        { text: "Tipo de postulante", value: "tipo_postulante" },
        { text: "Locacion", value: "locacion" },
        { text: "Tipo segun ubicacion", value: "tipo_persona" },
        { text: "Estado", value: "condicion", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      persona_items: [],

      //============== Data - Persona
      jefes_hogar: [
        { text: "Si", value: true },
        { text: "No", value: false },
      ],
      sexos: [
        { text: "Varon", value: "MA" },
        { text: "Mujer", value: "FE" },
      ],
      estadoscivil: [
        { text: "Soltero(a)", value: "SOLTERO(A)" },
        { text: "Comprometido(a)", value: "COMPROMETIDO(A)" },
        { text: "Conviviente", value: "CONVIVIENTE" },
        { text: "Casado(a)", value: "CASADO(A)" },
        { text: "Separado(a)", value: "SEPARADO(A)" },
        { text: "Divorciado(a)", value: "DIVORCIADO(A)" },
        { text: "Viudo(a)", value: "VIUDO(A)" },
      ],
      tipos_persona: [
        { text: "Local", value: "LOCAL" },
        { text: "Foraneo", value: "FORANEO" },
      ],
      tipos_postulante: [
        { text: "MONC Mano de obra no calificada", value: "MONC" },
        { text: "MOC Mano de obra calificada", value: "MOC" },
      ],
      searchpersonas: "",
      searchindividuo: "",
      editedIndex: -1,
      idindividuo: "",
      dni: "",
      nombres: "",
      apellidos: "",
      nombrecompleto: "",
      fecha_nacimiento: new Date().toISOString().substr(0, 10),
      sexo: "",
      telefono: "",
      email: "",
      estado_civil: "",
      jefe_hogar: false,
      grado_instruccion: "",
      tipo_persona: "",
      tipo_postulante: "",
      direccion: "",
      locaciones: [],
      personas: [],
      idlocacion: null,

      //============== Data - Actor social
      tipos_actor: [
        { text: "Individual", value: "INDIVIDUAL" },
        { text: "Grupal", value: "GRUPAL" },
      ],
      editedIndexStakeholder: -1,
      idactor: "",
      tipo_actor: "",
      abreviaturaactor: "",
      actor: "",
      descripcion: "",
      actores: [],
      headersactores: [
        { text: "Stakeholder", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],

      //============== Data - Experiencia
      editedIndexExperiencia: -1,
      experienciaid: "",
      experienciaempresa: "",
      experienciapuesto: "",
      experiencias_principal: [],
      experiencias: [],
      experienciaactual: false,
      experienciabateas: false,
      experienciafechainicio: "",
      experienciafechafin: "",
      //postulacionid: "",
      empleadoid: 0,
      requerimientoid: 0,
      contratoid: 0,
      areaid: "",
      areaarray: [],
      headerexperiencias: [
        { text: "Experiencia", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],

      //============== Data - Educacion
      editedIndexEducacion: -1,
      educacionid: "",
      educacioninstitucion: "",
      educacioninstituciones: [],
      educaciontipo_educacion: "",
      educacion_tipos: [
        { text: "Sin instruccion", value: "SIN INSTRUCCION" },
        { text: "Primaria", value: "PRIMARIA" },
        { text: "Secundaria", value: "SECUNDARIA" },
        { text: "Superior tecnico", value: "SUPERIOR TÉCNICO" },
        { text: "Practicante", value: "PRACTICANTE" },
        { text: "Superior universitario", value: "SUPERIOR UNIVERSITARIO" },
        { text: "Maestria", value: "MAESTRIA" },
        { text: "Doctorado", value: "DOCTORADO" },
      ],
      educaciondenominacion: "",
      educaciones_principal: [],
      educacion_principal: "",
      educaciones: [],
      headereducaciones: [
        { text: "Educacion", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],

      //============== Data - Conocimiento
      editedIndexConocimiento: -1,
      conocimientoid: "",
      conocimientoinstitucion: "",
      conocimientotipo_educacion: "",
      conocimientoinstituciones: [],
      conocimiento_tipos: [
        { text: "Curso", value: "CURSO" },
        { text: "Diplomado", value: "DIPLOMADO" },
        { text: "Otros", value: "OTROS" },
      ],
      conocimientos_principal: [],
      conocimientodenominacion: "",
      conocimientos: [],
      headerconocimientos: [
        { text: "Conocimiento", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],

      //============== Data - Documento
      editedIndexDocumento: -1,
      documentoid: "",
      documentonombre: "",
      documentoabreviatura: "",
      documentoruta: "",
      documentodescripcion: "",
      documentofecha_actualizacion: "",
      documentos: [],
      headeredocumentos: [
        { text: "Documentos", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],
      // ====== Otros
      upper: {
        "text-transform": "uppercase",
      },
    };
  },
  //============== Created
  created() {
    let me = this;
    me.listar();
    me.selectindividuo();
    me.selectlocaciones();
    me.selectEducacionPrincipal();
    me.selectExperienciaPrincipal();
    me.selectConocimiento();
    me.selectArea();
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );
    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },
  //============== Computed
  computed: {
    //============== Computed - Form Persona
    form1() {
      return {
        dni: this.dni,
        nombres: this.nombres,
        apellidos: this.apellidos,
        sexo: this.sexo,
        tipo_postulante: this.tipo_postulante,
        tipo_persona: this.tipo_persona,
        idlocacion: this.idlocacion,
      };
    },
    //============== Computed - Form Stakeholder
    form2() {
      return {
        tipo_actor: this.tipo_actor,
        actor: this.actor,
      };
    },
    //============== Computed - Forma Educacion
    form3() {
      return {
        educaciontipo_educacion: this.educaciontipo_educacion,
        //educaciondenominacion: this.educaciondenominacion,
        //educacioninstitucion: this.educacioninstitucion,
      };
    },
    //============== Computed - Form Experiencia
    form4() {
      return {
        experienciaempresa: this.experienciaempresa,
        experienciapuesto: this.experienciapuesto,
      };
    },
    //============== Computed - Form Conocimiento
    form5() {
      return {
        conocimientotipo_educacion: this.conocimientotipo_educacion,
        conocimientodenominacion: this.conocimientodenominacion,
      };
    },
    //============== Computed - Form Documentos
    form6() {
      return {
        documentonombre: this.documentonombre,
        documentodescripcion: this.documentodescripcion,
      };
    },
    //============== Computed - tieneRequerimiento
    /*tieneRequerimiento() {
      if(me.requerimientoid==0 || me.requerimientoid=="")
        return true;
      else
        return false;
    },*/
  },
  //============== Metodos
  methods: {
    tieneContrato(item) {
      if (item.idcontrato == 0) return false;
      else return true;
    },
    //============== Metodos - para formulario persona
    editItemPersona(item) {
      this.overlay = true;
      this.idindividuo = item.idindividuo;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    listar() {
      let me = this;
      axios
        .get("api/Individuos/Listar")
        .then(function (response) {
          me.persona_items = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    selectlocaciones() {
      // console.log("Entra a select locaciones");
      let me = this;
      var Array = [];
      me.locaciones = [];
      axios
        .get("api/Locaciones/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.locaciones.push({ text: x.locacion, value: x.idlocacion });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    selectindividuo() {
      let me = this;
      var Array = [];
      me.personas = [];
      axios
        .get("api/Individuos/Select")
        .then(function (response) {
          /*Array = response.data;
          Array.map(function (x) {
            me.personas.push({ text: x.nombrecompleto, value: x.idindividuo });
          });*/
          me.personas = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },
    customFilterPersona(item, queryText, itemText) {
      const textOne = item.nombrecompleto.toLowerCase();
      const textTwo = item.dni.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    editItem() {
      this.overlay = true;
      let me = this;
      me.selectlocaciones();
      var Array = [];
      axios
        .get("api/Individuos/Mostrar/" + me.idindividuo)
        .then(function (response) {
          console.log(response.data.idindividuo);
          me.idindividuo = response.data.idindividuo;
          me.dni = response.data.dni;
          me.nombres = response.data.nombres;
          me.apellidos = response.data.apellidos;
          me.fecha_nacimiento = response.data.fecha_nacimiento;
          me.sexo = response.data.sexo;
          me.telefono = response.data.telefono;
          me.email = response.data.email;
          me.estado_civil = response.data.estado_civil;
          me.jefe_hogar = response.data.jefe_hogar;
          me.tipo_postulante = response.data.tipo_postulante;
          me.tipo_persona = response.data.tipo_persona;
          me.direccion = response.data.direccion;
          me.idlocacion = response.data.idlocacion;
          me.editedIndex = 1;
          me.nuevo = false;
          me.listaractores();
          me.listarExperiencia();
          me.listarEducacion();
          me.listarConocimiento();
          me.listarDocumentos();
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    editItemIndividuo(item) {
      this.id = item.idindividuo;
      this.dni = item.dni;
      this.nombres = item.nombres;
      this.apellidos = item.apellidos;
      this.fecha_nacimiento = item.fecha_nacimiento;
      this.sexo = item.sexo;
      this.telefono = item.telefono;
      this.email = item.email;
      this.estado_civil = item.estado_civil;
      this.jefe_hogar = item.jefe_hogar;
      this.tipo_postulante = item.tipo_postulante;
      this.tipo_persona = item.tipo_persona;
      this.direccion = item.direccion;
      this.idlocacion = item.idlocacion;
      this.editedIndex = 1;
    },
    limpiar() {
      this.idindividuo = "";
      this.dni = "";
      this.fecha_nacimiento = new Date().toISOString().substr(0, 10);
      this.nombres = "";
      this.apellidos = "";
      this.tipo_persona = "";
      this.sexo = "";
      this.telefono = "";
      this.email = "";
      this.estado_civil = "";
      this.jefe_hogar = false;
      this.grado_instruccion = "";
      this.tipo_postulante = "";
      this.direccion = "";
      this.idlocacion = "";
      this.editedIndex = -1;
      this.limpiaractorestotal();
      this.limpiarEducacionTotal();
      this.limpiarExperienciaTotal();
      this.limpiarConocimientoTotal();
      this.limpiarDocumentosTotal();
      this.selectlocaciones();
      this.nuevo = true;
    },
    save() {
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndex > -1) {
          let me = this;
          axios
            .put("/api/Individuos/Actualizar", {
              idindividuo: me.idindividuo,
              dni: me.dni,
              nombres: me.nombres.toUpperCase(),
              apellidos: me.apellidos.toUpperCase(),
              fecha_nacimiento: me.fecha_nacimiento.toString(),
              sexo: me.sexo,
              telefono: me.telefono,
              email: me.email,
              estado_civil: me.estado_civil,
              jefe_hogar: me.jefe_hogar,
              tipo_postulante: me.tipo_postulante,
              tipo_persona: me.tipo_persona,
              direccion: me.direccion,
              idlocacion: me.idlocacion,
            })
            .then(function (response) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectindividuo();
              me.actualizarEmpleado();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        } else {
          let me = this;
          axios
            .post("/api/Individuos/Crear", {
              dni: me.dni,
              nombres: me.nombres.toUpperCase(),
              apellidos: me.apellidos.toUpperCase(),
              fecha_nacimiento: me.fecha_nacimiento,
              sexo: me.sexo,
              telefono: me.telefono,
              email: me.email,
              estado_civil: me.estado_civil,
              jefe_hogar: me.jefe_hogar,
              tipo_postulante: me.tipo_postulante,
              tipo_persona: me.tipo_persona,
              direccion: me.direccion,
              idlocacion: me.idlocacion,
            })
            .then(function (response) {
              me.idindividuo = Number(response.data);
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectindividuo();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        }
        //me.overlay2=true;
      }
    },
    actualizarEmpleado() {
      let me = this;
      axios
        .put("/api/Empleados/Actualizar2", {
          idindividuo: me.idindividuo,
          dni: me.dni,
          nombres: me.nombres.toUpperCase(),
          apellidos: me.apellidos.toUpperCase(),
          fecha_nacimiento: me.fecha_nacimiento.toString(),
          sexo: me.sexo,
          telefono: me.telefono,
          email: me.email,
          estado_civil: me.estado_civil,
        })
        .then(function (response) {
          console.log("Guarda datos en empleado");
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //============== Metodos para formulario stakeholder
    limpiaractores() {
      this.idactor = "";
      this.tipo_actor = "";
      this.actor = "";
      this.descripcion = "";
      this.abreviaturaactor = "";
      this.editedIndexStakeholder = -1;
    },
    limpiaractorestotal() {
      this.limpiaractores();
      this.actores = [];
    },
    listaractores() {
      let me = this;
      axios
        .get(
          "api/ActorSocials/GetStakeholderByIndividuo/?userid=" +
            me.idindividuo.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.actores = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    deleteItemActor(item) {
      this.overlay = true;
      let me = this;
      me.idactor = item.idstakeholder;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/ActorSocials/Eliminar/" + me.idactor)
          .then(function (response) {
            console.log("Se elimino");
            me.editedIndexStakeholder = -1;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.listaractores();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    editItemActor(item) {
      this.dialogstakeholder = true;
      this.idactor = item.idstakeholder;
      this.tipo_actor = item.tipo_stakeholder;
      this.actor = item.stakeholder;
      this.abreviaturaactor = item.abreviatura;
      this.descripcion = item.descripcion;
      this.editedIndexStakeholder = 1;
    },
    saveActores() {
      let me = this;
      me.validar2();
      if (me.form2HasErrors == false) {
        if (me.editedIndexStakeholder > -1) {
          let me = this;
          axios
            .put("/api/ActorSocials/Actualizar", {
              idstakeholder: me.idactor,
              tipo_stakeholder: me.tipo_actor,
              stakeholder: me.actor.toUpperCase(),
              abreviatura: me.abreviaturaactor,
              descripcion: me.descripcion,
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              me.snackbar = true;
              me.listaractores();
              me.limpiaractores();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogstakeholder = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        } else {
          console.log("Crear");
          let me = this;
          axios
            .post("/api/ActorSocials/Crear", {
              tipo_stakeholder: me.tipo_actor,
              stakeholder: me.actor.toUpperCase(),
              abreviatura: me.abreviaturaactor,
              descripcion: me.descripcion,
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              me.listaractores();
              me.limpiaractores();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogstakeholder = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        }
      }
    },

    //============== Metodos para formulario educacion
    customFilterEducacion(item, queryText, itemText) {
      const textOne = item.educacion.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    limpiarEducacion() {
      this.educacionid = "";
      this.educacioninstitucion = "";
      this.educaciontipo_educacion = "";
      this.educaciondenominacion = "";
      this.educaciondescripcion = "";
      this.educacionaño_inicio = "";
      this.educacionmes_inicio = "";
      this.educacionmes_fin = "";
      this.educacionaño_fin = "";
      this.editedIndexEducacion = -1;
    },
    limpiarEducacionTotal() {
      this.limpiarEducacion();
      this.educaciones = [];
    },
    deleteItemEducacion(item) {
      this.overlay = true;
      let me = this;
      me.educacionid = item.ideducacion;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Educacions/Eliminar/" + me.educacionid)
          .then(function (response) {
            console.log("Se elimino");
            me.editedIndexEducacion = -1;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.listarEducacion();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    listarEducacion() {
      let me = this;
      axios
        .get(
          "api/Educacions/GetEducacionsByIndividuo/?userid=" +
            me.idindividuo.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.educaciones = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItemEducacion(item) {
      this.dialogeducacion = true;
      this.educacionid = item.ideducacion;
      this.educacioninstitucion = item.institucion;
      this.educaciontipo_educacion = item.tipo_educacion;
      this.educaciondenominacion = item.denominacion;
      this.educaciondescripcion = item.descripcion;
      this.educacionaño_inicio = item.año_inicio;
      this.educacionmes_inicio = item.mes_inicio;
      this.educacionmes_fin = item.año_fin;
      this.educacionaño_fin = item.mes_fin;
      this.editedIndexEducacion = 1;
    },
    saveEducacionMatch() {
      let me = this;
      axios.post("/api/MatchEducaciones", {
        educacion: me.educaciondenominacion.toUpperCase(),
      });
    },
    selectEducacionPrincipal() {
      let me = this;
      var Array = [];
      me.educaciones_principal = [];
      axios
        .get("api/MatchEducaciones")
        .then(function (response) {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].educacion);
          }
          me.educaciones_principal = res;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    agregareducacion() {
      this.educaciondenominacion = this.educaciondenominacion.toUpperCase();
      this.educaciones_principal.push(
        this.educaciondenominacion.toString().toUpperCase()
      );
    },
    saveEducacion() {
      //console.log("ojo:"+this.educaciones_principal[this.educaciones_principal.length-1].toString());
      //console.log("Llega a entrar a crear educacion ojo"+this.);
      //this.$refs.sendReply.click();
      let me = this;
      me.validar3();
      console.log("Sale de valida 3" + me.form3HasErrors.toString());
      if (me.form3HasErrors == false) {
        console.log("Llega a entrar a crear educacion");
        me.saveEducacionMatch();
        if (this.editedIndexEducacion > -1) {
          let me = this;
          console.log("Actualizar");
          axios
            .put("/api/Educacions/Actualizar", {
              ideducacion: me.educacionid,
              institucion: me.educacioninstitucion.toUpperCase(),
              tipo_educacion: me.educaciontipo_educacion,
              denominacion: me.educaciondenominacion.toString().toUpperCase(),
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              me.listarEducacion();
              me.selectEducacionPrincipal();
              me.limpiarEducacion();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogeducacion = false;
            })
            .catch(function (error) {
              console.log(error.response);
              me.error = error.response.data.toString();
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.overlay2 = false;
              me.snackbar = true;
            });
        } else {
          console.log("Crear");
          let me = this;
          axios
            .post("/api/Educacions/Crear", {
              institucion: me.educacioninstitucion.toUpperCase(),
              tipo_educacion: me.educaciontipo_educacion,
              denominacion: me.educaciondenominacion.toString().toUpperCase(),
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              me.listarEducacion();
              me.limpiarEducacion();
              me.selectEducacionPrincipal();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogeducacion = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.overlay2 = false;
              me.snackbar = true;
            });
        }
      }
    },

    //============== Metodos para formulario conocimiento
    selectConocimiento() {
      let me = this;
      var Array = [];
      me.conocimientos_principal = [];
      axios
        .get("api/MatchConocimientos")
        .then(function (response) {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].conocimiento);
          }
          me.conocimientos_principal = res;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    agregarconocimiento() {
      this.conocimientodenominacion = this.conocimientodenominacion.toUpperCase();
      this.conocimientos_principal.push(
        this.conocimientodenominacion.toString()
      );
    },
    limpiarConocimiento() {
      this.conocimientoid = "";
      this.conocimientoinstitucion = "";
      this.conocimientotipo_educacion = "";
      this.conocimientodenominacion = "";
      this.conocimientoaño_inicio = "";
      this.conocimientomes_inicio = "";
      this.editedIndexConocimiento = -1;
    },
    limpiarConocimientoTotal() {
      this.limpiarConocimiento();
      this.conocimientos = [];
    },
    listarConocimiento() {
      let me = this;
      axios
        .get(
          "api/Conocimientos/GetConocimientosByIndividuo/?userid=" +
            me.idindividuo.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.conocimientos = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItemConocimiento(item) {
      this.dialogconocimiento = true;
      this.conocimientoid = item.idconocimiento;
      this.conocimientoinstitucion = item.institucion;
      this.conocimientotipo_educacion = item.tipo_educacion;
      this.conocimientodenominacion = item.denominacion;
      this.conocimientoaño_inicio = item.año_inicio;
      this.conocimientomes_inicio = item.mes_inicio;
      this.editedIndexConocimiento = 1;
    },
    deleteItemConocimiento(item) {
      this.overlay = true;
      let me = this;
      me.conocimientoid = item.idconocimiento;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Conocimientos/Eliminar/" + me.conocimientoid)
          .then(function (response) {
            console.log("Se elimino");
            me.editedIndexConocimiento = -1;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.listarConocimiento();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    saveConocimientoMatch() {
      let me = this;
      axios.post("/api/MatchConocimientos", {
        conocimiento: me.conocimientodenominacion.toUpperCase(),
      });
    },
    saveConocimiento() {
      let me = this;
      me.validar5();
      console.log("Entra a SaveConocimiento");
      //console.log(me.form5HasErrors);
      if (me.form5HasErrors == false) {
        console.log("pasa la validacion");
        me.saveConocimientoMatch();
        //me.saveInstitucionMatch2();
        console.log("Pasa match crear");
        if (this.editedIndexConocimiento > -1) {
          console.log("Entra actualizar");
          let me = this;
          axios
            .put("/api/Conocimientos/Actualizar", {
              idconocimiento: me.conocimientoid,
              institucion: me.conocimientoinstitucion.toUpperCase(),
              tipo_educacion: me.conocimientotipo_educacion,
              denominacion: me.conocimientodenominacion.toUpperCase(),
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              console.log("Actualizar");
              me.listarConocimiento();
              me.selectConocimiento();
              me.limpiarConocimiento();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogconocimiento = false;
            })
            .catch(function (error) {
              console.log(error.response);
              me.error = error.response.data.toString();
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.overlay2 = false;
              me.snackbar = true;
            });
        } else {
          console.log("Entra a crear");
          let me = this;
          axios
            .post("/api/Conocimientos/Crear", {
              institucion: me.conocimientoinstitucion.toUpperCase(),
              tipo_educacion: me.conocimientotipo_educacion,
              denominacion: me.conocimientodenominacion.toUpperCase(),
              idindividuo: me.idindividuo,
            })
            .then(function (response) {
              console.log("Crea");
              me.listarConocimiento();
              me.limpiarConocimiento();
              me.selectConocimiento();
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.dialogconocimiento = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.overlay2 = false;
              me.snackbar = true;
            });
        }
      }
    },

    //============== Metodos para formulario documento
    limpiarDocumentos() {
      this.documentoid = "";
      this.documentonombre = "";
      this.documentoabreviatura = "";
      this.documentoruta = "";
      this.documentodescripcion = "";
      this.documentofecha_actualizcion = "";
      this.editedIndexDocumento = -1;
    },
    limpiarDocumentosTotal() {
      this.limpiarDocumentos();
      this.documentos = [];
    },
    deleteItemDocumento(item) {
      this.overlay = true;
      let me = this;
      me.documentoid = item.iddocumento;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Documentos/Eliminar/" + me.documentoid)
          .then(function (response) {
            console.log("Se elimino");
            me.editedIndexDocumento = -1;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.listarDocumentos();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    listarDocumentos() {
      let me = this;
      axios
        .get(
          "api/Documentos/GetDocumentosByIndividuo/?userid=" +
            me.idindividuo.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.documentos = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItemDocumento(item) {
      this.dialogdocumento = true;
      this.documentoid = item.iddocumento;
      this.documentonombre = item.nombre;
      this.documentoabreviatura = item.abreviatura;
      this.documentoruta = item.ruta;
      this.documentodescripcion = item.descripcion;
      this.documentofecha_actualizcion = item.fecha_actualizacion;
      this.editedIndexDocumento = 1;
    },
    saveDocumento() {
      let me = this;
      console.log(this.documentoruta);
      me.validar6();
      if (me.form6HasErrors == false) {
        if (this.idindividuo || this.idindividuo != "") {
          if (this.editedIndexDocumento > -1) {
            let me = this;
            axios
              .put("/api/Documentos/Actualizar", {
                iddocumento: me.documentoid,
                nombre: me.documentonombre,
                abreviatura: me.documentoabreviatura,
                ruta: me.documentorutaruta,
                descripcion: me.documentodescripcion,
                fecha_actualizacion: new Date().toISOString().substr(0, 10),
                idindividuo: me.idindividuo,
              })
              .then(function (response) {
                me.snackbar = true;
                me.listarDocumentos();
                me.limpiarDocumentos();
                me.dialogdocumento = false;
              })
              .catch(function (error) {
                console.log(error.response);
              });
          } else {
            let me = this;
            axios
              .post("/api/Documentos/Crear", {
                nombre: me.documentonombre,
                abreviatura: me.documentoabreviatura,
                ruta: me.ruta,
                descripcion: me.documentodescripcion,
                fecha_actualizacion: new Date().toISOString().substr(0, 10),
                idindividuo: me.idindividuo,
              })
              .then(function (response) {
                me.snackbar = true;
                me.listarDocumentos();
                me.limpiarDocumentos();
                me.dialogdocumento = false;
              })
              .catch(function (error) {
                console.log(error.response);
              });
          }
        }
      }
    },

    //============== Metodos formulario Administracion
    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.idindividuo;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },
    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.listar();
      this.selectindividuo();
    },
    Activar() {
      let me = this;
      axios
        .put("/api/Individuos/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectindividuo();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    Desactivar() {
      let me = this;
      axios
        .put("/api/Individuos/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectindividuo();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //============== Metodos validacion y dialogs
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    abrirDialogEducacion() {
      this.dialogeducacion = true;
      this.limpiarEducacion();
      this.selectEducacionPrincipal();
    },
    abrirDialogExperiencia() {
      this.dialogexperiencia = true;
      this.limpiarExperiencia();
      this.selectExperienciaPrincipal();
    },
    abrirDialogConocimiento() {
      this.dialogconocimiento = true;
      this.limpiarConocimiento();
      this.selectConocimiento();
    },
    abrirDialogDocumento() {
      this.dialogdocumento = true;
      this.limpiarDocumentos();
    },
    abrirDialogStakeholder() {
      this.dialogstakeholder = true;
      this.limpiaractores();
    },
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;
        this.$refs[f].validate(true);
      });
    },
    validar2() {
      /*Validacion Forms */
      this.error = null;
      this.form2HasErrors = false;

      Object.keys(this.form2).forEach((f) => {
        if (!this.form2[f]) this.form2HasErrors = true;
        this.$refs[f].validate(true);
      });

      //if(this.educaciondenominacion !== null || this.educaciondenominacion!== "")
      //this.form2HasErrors=false;

      if (this.idindividuo == null || this.idindividuo == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form2HasErrors = true;
      }
    },
    validar3() {
      /*Validacion Forms */
      this.error = null;
      this.form3HasErrors = false;

      Object.keys(this.form3).forEach((f) => {
        if (!this.form3[f]) this.form3HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.idindividuo == null || this.idindividuo == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form3HasErrors = true;
      }
    },
    validar4() {
      /*Validacion Forms */
      this.error = null;
      this.form4HasErrors = false;

      Object.keys(this.form4).forEach((f) => {
        if (!this.form4[f]) this.form4HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.idindividuo == null || this.idindividuo == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form4HasErrors = true;
      }
    },
    validar5() {
      /*Validacion Forms */
      this.error = null;
      this.form5HasErrors = false;

      Object.keys(this.form5).forEach((f) => {
        if (!this.form5[f]) this.form5HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.idindividuo == null || this.idindividuo == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form5HasErrors = true;
      }
    },
    validar6() {
      /*Validacion Forms */
      this.error = null;
      this.form6HasErrors = false;

      Object.keys(this.form6).forEach((f) => {
        if (!this.form6[f]) this.form6HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.idindividuo == null || this.idindividuo == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form6HasErrors = true;
      }
    },

    //============== Metodos para formulario Experiencia
    selectArea() {
      let me = this;
      var Array = [];
      axios
        .get("api/Areas/Listar")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.areaarray.push({ text: x.empresa, value: x.idarea });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    reiniciarArea() {
      console.log("Reinicia areas");
      //this.areaarray.filter(function(x) { return x.ID == -1 });
      this.experienciaempresa = "";
      this.areaid = 0;
    },
    selectExperienciaPrincipal() {
      // console.log("Entra a select experiencia");
      let me = this;
      var Array = [];
      me.experiencias_principal = [];
      axios
        .get("api/MatchExperiencias")
        .then(function (response) {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].puesto);
          }
          me.experiencias_principal = res;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    customFilterExperiencia(item, queryText, itemText) {
      const textOne = item.experiencia.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    limpiarExperiencia() {
      console.log("Entra a limpiar experiencia");
      this.experienciaid = "";
      this.experienciaempresa = "";
      this.experienciapuesto = "";
      this.experienciafechainicio = "";
      this.experienciafechafin = "";
      this.experienciaactual = false;
      this.experienciabateas = false;
      this.areaid = 0;
      this.contratoid = 0;
      this.requerimientoid = 0;
      this.empleadoid = 0;
      this.editedIndexExperiencia = -1;
    },
    getEmpresa() {
      let me = this;
      me.empresa = "";
      axios
        .get("api/Areas/Mostrar/" + me.areaid.toString())
        .then((response) => {
          me.experienciaempresa = response.data.empresa;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    limpiarExperienciaTotal() {
      this.limpiarExperiencia();
      this.experiencias = [];
    },
    listarExperiencia() {
      let me = this;
      console.log("Entra a listar experiencia");
      me.expecincias = [];
      axios
        .get(
          "api/Experiencias/GetExperienciasByIndividuo/?userid=" +
            me.idindividuo.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.experiencias = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItemExperencia(item) {
      this.dialogexperiencia = true;
      this.experienciaid = item.idexperiencia;
      this.experienciaempresa = item.empresa;
      this.experienciapuesto = item.puesto;
      this.experienciafechainicio = item.fechainicio;
      this.experienciafechafin = item.fechafin;
      this.experienciaactual = item.actual;
      this.experienciabateas = item.bateas;
      this.contratoid = item.idcontrato;
      this.getArea();
      this.editedIndexExperiencia = 1;
    },
    saveExperienciasMatch() {
      let me = this;
      axios.post("/api/MatchExperiencias", {
        puesto: me.experienciapuesto.toUpperCase(),
      });
    },
    saveExperienciaFinal() {
      let me = this;
      me.validar4();
      if (me.form4HasErrors == false) {
        me.saveExperienciasMatch();
        if (me.editedIndexExperiencia > -1) {
          //Actualizar experiencia
          if (me.experienciabateas) {
            me.existeEmpleado();
          } else {
            me.actualizarExperiencia();
          }
        } else {
          //Guardar experiencia
          if (me.experienciabateas) {
            me.existeEmpleado();
          } else {
            me.saveExperencia();
          }
        }
      }
    },
    existeEmpleado() {
      let me = this;
      axios
        .post("/api/Empleados/ExisteEmpleado", {
          dni: me.dni,
        })
        .then(function (response) {
          me.empleadoid = Number(response.data);
          console.log("Id empleado existe: " + me.empleadoid);
          if (me.empleadoid == 0) {
            me.guardarEmpleadoFinal();
          } else {
            me.guardarContrato();
          }
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    //Saveexperiencia - Crear: -> Orden 0
    guardarEmpleadoFinal() {
      let me = this;
      if (me.experienciabateas == true) {
        axios
          .post("/api/Empleados/Crear", {
            dni: me.dni,
            nombres: me.nombres.toUpperCase(),
            apellidos: me.apellidos.toUpperCase(),
            fecha_nacimiento: me.fecha_nacimiento,
            sexo: me.sexo,
            telefono: me.telefono,
            email: me.email,
            estado_civil: me.estado_civil,
            usuario: "",
            contraseña: "",
            idarea: me.areaid,
            condicion: true,
            rol: "NINGUNO",
            tipo: "EMPLEO",
          })
          .then(function (response) {
            me.empleadoid = Number(response.data);
            console.log("Save empleado: " + me.empleadoid.toString());
            //me.actualizarEmpleadoExperiencia(me.empleadoid);
            me.guardarContrato();
          })
          .catch(function (error) {
            console.log(error.response);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.overlay2 = false;
            me.snackbar = true;
          });
      } else {
        me.saveExperencia();
      }
    },
    //Saveexperienciafinal - Crear: -> Orden 1
    guardarContrato() {
      let me = this;
      axios
        .post("/api/Contratos/Crear", {
          fecha_inicio: me.experienciafechainicio,
          fecha_fin: me.experienciafechafin,
          idempleado: me.empleadoid,
          condicion: true,
          idrequerimiento: 0,
          idarea: me.areaid,
          puesto: me.experienciapuesto.toUpperCase(),
        })
        .then(function (response) {
          me.contratoid = Number(response.data);
          console.log("Save contrato: " + me.contratoid.toString());
          //me.actualizarEmpleadoExperiencia(me.empleadoid);
          me.saveExperencia();
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },
    //Saveexperienciafinal - Crear: -> Orden 2
    saveExperencia() {
      let me = this;
      axios
        .post("/api/Experiencias/Crear", {
          empresa: me.experienciaempresa.toUpperCase(),
          puesto: me.experienciapuesto.toUpperCase(),
          fechainicio: me.experienciafechainicio,
          fechafin: me.experienciafechafin,
          actual: me.experienciaactual,
          bateas: me.experienciabateas,
          idindividuo: Number(me.idindividuo),
          idcontrato: Number(me.contratoid),
        })
        .then(function (response) {
          me.experienciaid = Number(response.data);
          console.log("Experiencia creada" + me.experienciaid.toString());
          me.activardesactivarCondicionEmpleo();
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },
    //Saveexperienciafinal - Crear: -> Orden 3
    activardesactivarCondicionEmpleo() {
      console.log("Entra para activar y desactivar");
      let me = this;
      if (me.experienciaactual == true) {
        axios
          .put("/api/Individuos/ActivarEmpleo/" + me.idindividuo, {})
          .then(function (response) {
            console.log("Activar condicion empleo");
            me.listarExperiencia();
            me.limpiarExperiencia();
            me.selectExperienciaPrincipal();
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.dialogexperiencia = false;
          })
          .catch(function (error) {
            console.log(error.response);
          });
      } else {
        let me = this;
        axios
          .put("/api/Individuos/DesactivarEmpleo/" + me.idindividuo, {})
          .then(function (response) {
            console.log("Desactivar condicion empleo");
            me.listarExperiencia();
            me.limpiarExperiencia();
            me.selectExperienciaPrincipal();
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.dialogexperiencia = false;
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
    },
    //Saveexperienciafinal - Actualizar: -> Orden 3
    actualizarExperiencia() {
      let me = this;
      axios
        .put("/api/Experiencias/Actualizar", {
          idexperiencia: Number(me.experienciaid),
          empresa: me.experienciaempresa.toUpperCase(),
          puesto: me.experienciapuesto.toUpperCase(),
          fechainicio: me.experienciafechainicio,
          fechafin: me.experienciafechafin,
          actual: me.experienciaactual,
          bateas: me.experienciabateas,
          idindividuo: Number(me.idindividuo),
        })
        .then(function (response) {
          console.log("Actualiza experiencia");
          //me.actualizarEmpleadoFinal();
          me.activardesactivarCondicionEmpleo();
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },

    //Saveexperiencia - Crear: -> Orden 2
    //Saveexperiencia - Actualizar: -> Orden 2
    /*
    actualizarEmpleadoExperiencia(p_empleadoid) {
      let me = this;
      console.log("Entra para actualizar id empleado en experiencia");
      axios
        .put("/api/Experiencias/ActualizarEmpleado", {
          idexperiencia: Number(me.experienciaid),
          idempleado: Number(p_empleadoid),
        })
        .then(function (response) {
          console.log("Actualiza ID empleado en experiencia");
          me.activardesactivarCondicionEmpleo();
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },*/
    //Saveexperiencia - Crear: -> Orden 3 (final)
    //Saveexperiencia - Actualizar: -> Orden 3 (final)

    //Saveexperiencia - Actualizar: -> Orden 1
    /*actualizarEmpleadoFinal() {
      let me = this;
      if (me.experienciabateas == true) {
        if (me.empleadoid != 0) {
          console.log("Actualiza datos de empleado");
          axios
            .put("/api/Empleados/Actualizar", {
              idempleado: Number(me.empleadoid),
              dni: me.dni,
              nombres: me.nombres.toUpperCase(),
              apellidos: me.apellidos.toUpperCase(),
              fecha_nacimiento: me.fecha_nacimiento,
              sexo: me.sexo,
              telefono: me.telefono,
              email: me.email,
              estado_civil: me.estado_civil,
              usuario: "",
              contraseña: "",
              idarea: me.areaid,
              condicion: false,
              rol: "NINGUNO",
              fechainicio: me.experienciafechainicio,
              fechafin: me.experienciafechafin,
            })
            .then(function (response) {
              console.log("Actualiza datos empleado");
              me.actualizarEmpleadoExperiencia(me.empleadoid);
            })
            .catch(function (error) {
              console.log(error.response);
            });
        } else {
          me.guardarEmpleadoFinal();
        }
      } else {
        console.log("No es en bateas");
        let idayuda = me.empleadoid;
        if (me.empleadoid != 0) {
          console.log("Va para eliminar empleado");
          me.deleteEmpleado(idayuda);
        }
        me.actualizarEmpleadoExperiencia(Number(0));
      }
    },*/

    deleteItemExperiencia(item) {
      this.overlay = true;
      let me = this;
      me.experienciaid = item.idexperiencia;
      me.empleadoid = item.idempleado;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Experiencias/Eliminar/" + me.experienciaid)
          .then(function (response) {
            console.log("Se elimino experiencia");
            //me.deleteEmpleado(me.empleadoid);
            me.activardesactivarCondicionEmpleo();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    //Eliminar empleado
    /*
    deleteEmpleado(p_id) {
      let me = this;
      me.overlay = true;
      if (p_id != 0) {
        console.log("Entra a diferente de cero siendo: " + p_id);
        axios
          .delete("/api/Empleados/Eliminar/" + p_id)
          .then(function (response) {
            console.log("Se elimino empleado");
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
      me.overlay = false;
    },*/

    getArea() {
      this.overlay = true;
      let me = this;
      if (me.experienciabateas == true) {
        axios
          .get("api/Empleados/Mostrar/" + me.empleadoid)
          .then(function (response) {
            console.log("Traer area");
            me.areaid = response.data.idarea;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.overlay = false;
    },
    agregarexperiencia() {
      this.experianciapuesto = this.experienciapuesto.toUpperCase();
      this.experiencias_principal.push(this.experienciapuesto.toString());
    },
    uppercase_nombres() {
      this.nombres = this.nombres.toUpperCase();
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
/*
.v-input input {
    max-height: 32px;
    text-transform: uppercase;
}
input {
  text-transform: uppercase;
}
::-webkit-input-placeholder { /* WebKit browsers */
/*    text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
/*    text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
/*    text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
/*    text-transform: none;
}*/
</style>